import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { InternalInfoClosePopupModel, RESULT_TYPES } from '@evorait/pace-core';

@Component({
    selector: 'pace-internal-info-close-popup',
    templateUrl: './internal-info-close-popup.component.html',
    styleUrls: ['./internal-info-close-popup.component.scss'],
    standalone: false,
})
export class InternalInfoClosePopupComponent {
    @Input()
    public model: InternalInfoClosePopupModel;

    public modalResult = new Subject<RESULT_TYPES>();
    public constructor(public readonly modalInstance: BsModalRef) {}

    public onYesClicked(): void {
        this.modalResult.next(RESULT_TYPES.YES);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public onNoClicked(): void {
        this.modalResult.next(RESULT_TYPES.NO);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public onBackClick(): void {
        this.modalResult.next(RESULT_TYPES.BACK);
        this.modalResult.complete();
        this.modalInstance.hide();
    }
}
